import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TimeagoPipe } from '@apply4u/shared/pipes/timeago.pipe';
import { LocalDateTimePipe } from '@apply4u/shared/pipes/local-date-time.pipe';
import { FormsModule } from '@angular/forms';
import { JobWishListModalModule } from '@apply4u/shared/components/job-wish-list-modal/job-wish-list-modal.module';
import { ShareJobModalModule } from '@apply4u/shared/components/share-job-modal/share-job-modal.module';
import { JobDetailComponent } from './component/job-detail.component';
import { CompanyProfileUrlPipe } from '@apply4u/shared/pipes/company-profile-url.pipe';
import { TalentMessengerService } from '@apply4u/services/talent-messenger/talent-messenger.service';
import { SearchBarModule } from '@apply4u/shared/components/search/search-bar/search-bar.module';
import { RecommendationsModalModule } from '@apply4u/shared/components/recommendations-modal/recommendations-modal.module';
import { HighlightPipe } from '@apply4u/shared/pipes/highlight.pipe';
import { HighlightsPipe } from '@apply4u/shared/pipes/highlights.pipe';
import { JobApplyNowUrlPipe } from '@apply4u/shared/pipes/job-apply-now-url.pipe';
import { JobBySectorUrlPipe } from '@apply4u/shared/pipes/job-by-sector-url.pipe';
import { SafeHtmlPipe } from '@apply4u/shared/pipes/safehtml.pipe';
import { SplitSkillsPipe } from '@apply4u/shared/pipes/split-skills-pipe.pipe';
import { SearchByLocationSmartPipe } from '@apply4u/shared/pipes/search-by-location-smart.pipe';
import { SimilarJobsPipe } from '@apply4u/shared/pipes/similar-jobs-pipe';

const routes: Routes = [
  { path: '', component: JobDetailComponent}
]

@NgModule({
  declarations: [JobDetailComponent],
  imports: [
    CommonModule,
    FormsModule,
    HighlightPipe,
    HighlightsPipe,
    SafeHtmlPipe,
    TimeagoPipe,
    LocalDateTimePipe,
    JobBySectorUrlPipe,
    JobApplyNowUrlPipe,
    JobWishListModalModule,
    ShareJobModalModule,
    RouterModule.forChild(routes),
    CompanyProfileUrlPipe, 
    SearchBarModule,
    SplitSkillsPipe,
    SearchByLocationSmartPipe, 
    RecommendationsModalModule,
    SimilarJobsPipe
  ],
  providers: [TalentMessengerService],
  exports: [RouterModule]
})
export class JobDetailModule { }
